import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';

/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function createPaperProfileReducer(state = initialState.newPaperProfileId, action) {
	switch (action.type) {
		case types.CREATE_PAPER_PROFILE_METADATA: {
			return action.response.id ? action.response.id : state;
		}
		case types.ADD_DOCUMENTS_TO_TASKS: {
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return null;
			}
			return state;
		}
		default:
			return state;
	}
}
